import React from 'react'
import { Provider } from 'react-redux'
import { MuiThemeProvider } from '@material-ui/core/styles'
import theme from '../../theme'
import Routes from '../../routes'
import configureStore from '../../AppRedux/store'
import './App.css'
import { BrowserRouter, Route } from 'react-router-dom'
import { getGAEnvironment, pushToDataLayer } from '../../utils/gaEnvironment'

export const store = configureStore()

const App = () => {
  pushToDataLayer({ event: "gtm.js", env: getGAEnvironment() })

  return (
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <BrowserRouter>
          <Route path="/" component={Routes} />
        </BrowserRouter>
      </Provider>
    </MuiThemeProvider>
  )
}

export default App
